import React from "react";
import { Link, useParams } from "react-router-dom";
import "./FreeLegalAdviceCSS.css";
import LegalBradcrumeSection from "./LegalBradcrumeSection";
import { AnswersBox, QuestionBox } from "./QuestionAnswereBox";
import LegalProfileBox from "./LegalProfileBox";
import { AllCommunityAnswear, UserProfileData } from "../FetchAPI";
import CommunityAnswersForm from "./CommunityAnswersForm";
import PageMetaTags from "../Others/PageMetaTags";
import { useAuth } from "../../Store/AuthContext";

export default function QuestionAnswereDetails() {
  const { RendomTokenfetch } = useAuth();
  let { questionslug } = useParams();
  const [userData] = UserProfileData(RendomTokenfetch);
  const userRoll = userData.role;

  const [communitySerAns, serviceQues] = AllCommunityAnswear(
    RendomTokenfetch,
    questionslug
  );
  let QuestionID = "";
  if (serviceQues) {
    if (serviceQues.id) {
      QuestionID = serviceQues.id;
    }
  }

  // console.log(communitySerAns);

  let ShowCommunityAnswersForm;

  const ShowCommentFunction = (RendomTokenfch, QuestID) => {
    if (serviceQues.answer_by_role === "") {
      ShowCommunityAnswersForm = "";
    } else {
      if (serviceQues.answer_by_role === "0") {
        ShowCommunityAnswersForm = (
          <div className="ShowCommnetboxAnswers">
            <div className="CommnetAnsweraAddbox text-center mt-5 ">
              <h4 className="">Comments by Users</h4>
            </div>
            <div className="formdesedataBOX mt-3">
              <div className="formdesctitlebox">
                <p className="formdescPera">
                  No Comments! Be the first one to comment.
                </p>
                <div className="formDatarow px-3">
                  <CommunityAnswersForm
                    RendomTokenfetch={RendomTokenfch}
                    QuestionID={QuestID}
                  />
                </div>
              </div>
            </div>
          </div>
        );
      } else {
        if (serviceQues.answer_by_role === userRoll) {
          ShowCommunityAnswersForm = (
            <div className="ShowCommnetboxAnswers">
              <div className="CommnetAnsweraAddbox text-center mt-5 ">
                <h4 className="">Comments by Users</h4>
              </div>
              <div className="formdesedataBOX mt-3">
                <div className="formdesctitlebox">
                  <p className="formdescPera">
                    No Comments! Be the first one to comment.
                  </p>
                  <div className="formDatarow px-3">
                    <CommunityAnswersForm
                      RendomTokenfetch={RendomTokenfch}
                      QuestionID={QuestID}
                    />
                  </div>
                </div>
              </div>
            </div>
          );
        }
      }
    }

    return ShowCommunityAnswersForm;
  };

  return (
    <>
      <PageMetaTags
        meta_title={serviceQues.meta_title && serviceQues.meta_title}
        metakeyword={serviceQues.metakeyword && serviceQues.metakeyword}
        metadesc={serviceQues.metadesc && serviceQues.metadesc}
      />
      <LegalBradcrumeSection
        Pagename={serviceQues.subject}
        // Pagename={"sdfds"}
        page1={[
          { name: `free-advice`, pagelink: "free-advice" },
          { name: `advice-question` },
          {
            name: `${questionslug}`,
          },
        ]}
      />

      <section
        className={`legal_section section_padding_top section_padding_bottom `}
        style={{ background: " #f5f7fc82" }}
      >
        <div className="auto-container">
          <div className="row wow fadeInUp">
            <div className="col-lg-8 col-md-12 Askformrow">
              <div className="questionAnsBox">
                <QuestionBox serviceQues={serviceQues} />
              </div>
              <div className="legalAnswereBox mt-5">
                {communitySerAns && communitySerAns.length > 0 ? (
                  <>
                    <div className="legalAnstitlebox text-center mb-3">
                      <h4 className="">Answers ({communitySerAns.length})</h4>
                    </div>
                    <AnswersBox
                      RendomTokenfetch={RendomTokenfetch}
                      communitySerAns={communitySerAns}
                      QuestionID={QuestionID}
                    />
                  </>
                ) : (
                  <div className="text-center notfountCommunityQues">
                    <p className="NotFountHeading">No Answers Found.</p>
                    <p>
                      Get <Link to="/ask-a-free-question">free advice</Link>{" "}
                      from top rated experts in India.
                    </p>
                  </div>
                )}
              </div>
              {ShowCommentFunction(RendomTokenfetch, QuestionID)}
            </div>

            <div className="col-lg-4">
              <LegalProfileBox />
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
